module.exports = __webpack_public_path__ + "static/media/matilde-hat-china-bored.c52dfdb5.png";